<div class="toolbar">
  <div class="total-label">Total:</div>
  <div class="total-value">{{ total }}</div>
  <span class="flex-spacer"></span>
  <button class="btn-all" mat-stroked-button color="primary" (click)="withdrawAll()">Withdraw All</button>
  <button class="btn-all" mat-stroked-button color="accent" (click)="transferAll()">Transfer All</button>
</div>

<div *ngIf="loading" class="status">Loading…</div>
<div *ngIf="error" class="status error">{{ error }}</div>

<table mat-table [dataSource]="activeChannelsCommits" *ngIf="!loading">

  <ng-container matColumnDef="property">
    <th mat-header-cell *matHeaderCellDef> Property </th>
    <td mat-cell *matCellDef="let el"> {{ el.propertyId }} </td>
  </ng-container>

  <ng-container matColumnDef="column">
    <th mat-header-cell *matHeaderCellDef> Column </th>
    <td mat-cell *matCellDef="let el"> {{ el.column }} </td>
  </ng-container>

  <ng-container matColumnDef="channel">
    <th mat-header-cell *matHeaderCellDef> Channel </th>
    <td mat-cell *matCellDef="let el">
      <span class="copyable" (click)="copy(el.channel)">{{ el.channel }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="counterparty">
    <th mat-header-cell *matHeaderCellDef> Counterparty </th>
    <td mat-cell *matCellDef="let el">
      <span class="copyable" (click)="copy(el.counterparty)">{{ el.counterparty || '—' }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef> Amount </th>
    <td mat-cell *matCellDef="let el"> {{ el.amount }} </td>
  </ng-container>

  <ng-container matColumnDef="block">
    <th mat-header-cell *matHeaderCellDef> Block </th>
    <td mat-cell *matCellDef="let el"> {{ el.lastCommitmentBlock || '—' }} </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> Actions </th>
    <td mat-cell *matCellDef="let el" class="row-actions">
      <button mat-icon-button matTooltip="Withdraw" (click)="withdraw(el)">
        <mat-icon>call_made</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Transfer" (click)="transfer(el)">
        <mat-icon>sync_alt</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackByChan"></tr>
</table>
